import { curry, PlatformEvent } from 'lib/util'
import listConnectionStatuses from 'app/_shared/events/collection/bluetooth/listConnectionStatus'
import { BLE_PERIPHERAL_CONNECTION_STATUS } from 'model/_shared/collection/bluetooth/constants'

/**
 * Get Connection Status
 *
 * Retrieves the current Bluetooth connection status for a peripheral device and returns
 * a list of connection statuses.
 *
 * @param module - the application module specification
 * @param component - the component specification
 * @param event - the platform event
 *
 * @returns {Array} the list of connection statuses
 */
const getConnectionStatus = (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: PlatformEvent,
): Array<any> => {
  const { [G.BLUETOOTH]: bluetoothAdapter } = module[G.ADAPTER]
  const { sensor: model } = module[G.MODEL][G.CHILDREN]
  const { value: { name } } = model[G.CACHE]
  const peripheral = bluetoothAdapter[G.GROUP][name]

  const {
    connectionStatus = BLE_PERIPHERAL_CONNECTION_STATUS.DISCONNECTED
  } = peripheral?.[G.STATE] || {}

  return listConnectionStatuses(module, component, connectionStatus)
}

export default curry(getConnectionStatus)
